<template>
  <div>
    <div>
      <BaseInputLabel :text="$t(`global.items.${resource.type}`, 1)" />
    </div>
    <div :class="$style.disabledResource">
      <BaseAvatar :resource="resource" />
      <BaseText>{{ resource.name }}</BaseText>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useResourcesStore } from '@/stores/resources';

export default defineComponent({
  props: {
    allocation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    resource() {
      const { resourceById } = useResourcesStore();
      return resourceById(this.allocation.resourceId);
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.disabledResource {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
  height: $input-height;
}
</style>
